export default __webpack_public_path__ + "static/media/pebblo-logo.01313ea9.png";